<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item label="公告标题">
        <el-input style="width: 250px" size="mini" v-model="formData.title" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="公告标签">
        <el-input style="width: 250px" size="mini" v-model="formData.tag" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="发布日期" >
        <el-date-picker type="date" placeholder="选择日期" v-model="formData.date1" style="width: 250px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="公告内容">
      <Editor ref="editor" :showBtn="false" :content.sync="formData.content"></Editor>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formData.status" placeholder="请选择" size="small">
          <el-option label="待审核" value="0"> </el-option>
          <el-option label="下架" value="10"> </el-option>
          <el-option label="发布" value="20"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number  style="width: 250px" v-model="formData.sort" size="small" placeholder="请输入"></el-input-number>
      </el-form-item>
      <el-form-item label="">
        <el-button type="" size="small" @click="$router.back()">取 消</el-button>
        <el-button type="primary" size="small" @click="save">保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addAPI, editAPI, getDetailAPI } from './api'
import Editor from '@/components/editor/index.vue'

export default {
  name: 'Update',
  components: { Editor },
  data() {
    return {
      formData: {
        title: '',
        tag: '',
        publish_date: '',
        content: '',
        sort: 0,
      },
      type: 0,
    }
  },

  mounted() {
    if (this.$route.params.id) this.getDetail()
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.$router.back()
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('新增成功')
              this.$router.back()
            })
          }
        }
      })
    },
    async getDetail () {
      this.formData = await getDetailAPI(this.$route.params.id)
    }
  }
}
</script>
